var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGrayVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27117 1.42902C6.67367 1.08486 7.33284 1.08486 7.74117 1.42902L8.66284 2.22236C8.83784 2.37402 9.16451 2.49652 9.39784 2.49652H10.3895C11.0078 2.49652 11.5153 3.00402 11.5153 3.62236V4.61402C11.5153 4.84152 11.6378 5.17402 11.7895 5.34902L12.5828 6.27069C12.927 6.67319 12.927 7.33236 12.5828 7.74069L11.7895 8.66236C11.6378 8.83736 11.5153 9.16402 11.5153 9.39736V10.389C11.5153 11.0074 11.0078 11.5149 10.3895 11.5149H9.39784C9.17034 11.5149 8.83784 11.6374 8.66284 11.789L7.74117 12.5824C7.33867 12.9265 6.6795 12.9265 6.27117 12.5824L5.3495 11.789C5.17451 11.6374 4.84784 11.5149 4.61451 11.5149H3.60534C2.987 11.5149 2.47951 11.0074 2.47951 10.389V9.39152C2.47951 9.16402 2.35701 8.83736 2.21117 8.66236L1.42367 7.73486C1.08534 7.33236 1.08534 6.67902 1.42367 6.27652L2.21117 5.34902C2.35701 5.17402 2.47951 4.84736 2.47951 4.61986V3.61652C2.47951 2.99819 2.987 2.49069 3.60534 2.49069H4.61451C4.84201 2.49069 5.17451 2.36819 5.3495 2.21652L6.27117 1.42902Z",
    fill: "#C1C1C1",
    stroke: "#C1C1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 6.99956L6.29451 8.41122L9.11201 5.58789",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 6.99956L6.29451 8.41122L9.11201 5.58789",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayVerify);
export default __webpack_public_path__ + "static/media/gray-verify.ceacd61b485337c00d36d5c45c2ab17d.svg";
export { ForwardRef as ReactComponent };